<template>
    <div>
        <Content :style="{padding: '24px', minHeight: '480px', background: '#fff'}">
            <el-alert type="info" effect="dark" :closable="false">
                <div style="line-height: 2;font-size: 16px" solt="description">
                    跨境货代可以直接打印面单以及下载面单
                    <br>
                    本土货代可以直接内部交接单以及打印本土面单【会跳转到官网进行列印，部分需要翻墙】
                </div>
            </el-alert>
            <el-form ref="queryParams" inline label-position="right" style="margin-top: 20px" label-width="80px" @keydown.native.enter.prevent="()=>{}">
                <el-form-item label="包裹单号">
                    <el-input ref="expressNo" size="small" v-model="expressNo" @keyup.enter.native="toGo" placeholder="包裹单号" style="width: 240px" />
                    <el-checkbox style="margin-left:10px;" v-model="showOk" @change="setMouse">固定鼠标</el-checkbox>

                    <el-checkbox style="margin-left:10px;" v-model="outgoOk">打印后出库</el-checkbox>

                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="danger" @click="setDayin">
                        <template v-if="!printName">设置打印机</template>
                        <template v-else>已选打印机:{{printName}}</template> </el-button>
                    <label>已安装用户，重启打印控件以及刷新当前页面</label>
                </el-form-item>
            </el-form>
            <Table :loading="loading" :columns="columns" :data="orders" border>
            </Table>
            <Timeline style="margin-top: 10px">
                <TimelineItem v-for="(order,ind) in resultOrders" :key="ind">
                    <p class="time">{{order.expressNo}}</p>
                    <p class="content">
                        【<a target="_blank" :href="'/#/waybillexpress/show/'+order.expressNo">快递单号：{{order.expressNo}}</a>】
                        <a target="_blank" v-if="order.state==1" :href="'/#/waybill/show/'+order.waybillOrder">【货运单号：{{order.waybillOrder}}】</a>
                        {{order.state==1?'扫描成功'+order.msg:order.msg}}
                    </p>
                </TimelineItem>
            </Timeline>
            </el-row>
            <CWaybillError :show="showError" @ok="showError=false;" @cancel="showError=false" :waybillId="waybill.id"></CWaybillError>
            <CWaybillBig :show="showBig" @ok="showBig=false;waybill.big=1" @cancel="showBig=false" :waybillId="waybill.id"></CWaybillBig>
            <CWaybillGap :show="showGap" @ok="showGap=false;" @cancel="showGap=false" :waybillId="waybill.id"></CWaybillGap>
            <CWaybillBack :show="showBack" @ok="showBack=false;waybill.state=-1;" @cancel="showBack=false" :waybillId="waybill.id"></CWaybillBack>
            <CWaybillExpressRemark :waybillExpress="waybillExpress" :show="showRemark" @ok="remarkOk" @cancel="showRemark=false;"></CWaybillExpressRemark>
            <CWaybillExpressBack :show="showExpressBack" @ok="backOk" @cancel="showExpressBack=false" :state="state" :waybillExpress="waybillExpress"></CWaybillExpressBack>
            <Modal :title="title" v-model="visible" :width="800">
                <img :src="imgName" v-if="visible" style="width: 100%">
            </Modal>
            <CXiapiLogistics :waybill="waybill" @cancel="xiapiLogCancel" :show="xiapiLogShow"></CXiapiLogistics>
            <CPrintSet :defaultPrinter="printName" :printers="printers" @cancel="printerShow=false" @ok="printSetOk" :show="printerShow"></CPrintSet>
        </Content>
    </div>
</template>
<script>
import { getRand } from "@/utils/random"
import CPrintSet from './CPrintSet.vue'
import iNotify from '@/assets/iNotify';
import Constants from '@/utils/constants'
import CXiapiLogistics from '../Waybill/CXiapiLogistics.vue'
import CWaybillBig from '../Waybill/CWaybillBig.vue'
import CWaybillGap from '../Waybill/CWaybillGap.vue'
import CWaybillBack from '../Waybill/CWaybillBack.vue'
import CWaybillError from '../Waybill/CWaybillError.vue'
import CWaybillExpressBack from '../WaybillExpress/CWaybillExpressBack.vue'
import CWaybillExpressRemark from '../WaybillExpress/CWaybillExpressRemark.vue'
import api from '@/api/api';
export default {
    name: 'Express',
    data() {
        return {
            fouceTimer: null,
            showError: false,
            printerShow: false,
            printers: [],
            printName: "",
            socket: null,
            currentIndex: null,
            selected: [],
            xiapiLogShow: false,
            showOk: true,
            outgoOk:false,
            showBig: false,
            showGap: false,
            showRemark: false,
            showExpressBack: false,
            state: 0,
            waybillExpress: {},
            imgName: "",
            title: "",
            visible: false,
            showBack: false,
            waybill: {

            },


            expressNo: "",
            expressNo2: "",
            orders: [],
            loading: false,
            resultOrders: [],
            root: api.root,
            columns: [{

                    filters: [{
                            label: '显示已出库',
                            value: 1
                        },
                        {
                            label: '不显示出库',
                            value: 2
                        }
                    ],
                    filterMultiple: false,
                    filterMethod(value, row) {
                        if (value === 1) {
                            return row.state == 4;
                        } else if (value === 2) {
                            return row.state != 4;
                        }
                    },
                    title: '运单号',
                    key: 'waybillOrder',
                    width: 220,
                    className: 'tabname',
                    align: 'center',
                    render: (h, params) => {
                        var btns = [];
                        var row = params.row;
                        var subS = [];
                        var me = this;
                        btns.push(h("div", { class: "sub-title" }, [
                            h("div", { class: params.row.cross == 1 ? 'packageName' : 'packageName cross' }, (params.row.cross == 1 ? '跨境订单' : '本土订单') + "，出货时间:" + me.long2date(params.row.shipByDate))
                        ]));

                        var sps = [h("span", { class: Constants.getXiapiOrderStatusClass(params.row.orderStatus) }, Constants.getXiapiOrderStatus(params.row.orderStatus))];

                        var as = [];
                        if (params.row.asyncLoading) {
                            as.push(h("Button", { props: { icon: "ios-refresh", loading: true, type: "primary" } }));
                        }
                        as.push(h("span", { class: "logisticInfo" }, params.row.lastLogistics ? params.row.lastLogistics : "查看物流"));

                        sps.push(h("div", { style: { marginTop: "5px" } },
                            [
                                h("a", {
                                    class: "state-info",
                                    on: {
                                        click: () => {
                                            this.waybill = params.row;
                                            this.xiapiLogShow = true;
                                        }
                                    }
                                }, as)
                            ]
                        ));


                        btns.push(h("div", { style: { marginBottom: "5px" } }, sps));


                        // if (params.row.shopId == 1) {
                        //     btns.push(h("div", { style: { color: "#ff0000", textAlign: "center", fontSize: "14px" } }, Constants.getShopType(row.shopId)));
                        // } else {
                        //     btns.push(h("div", { style: { textAlign: "center" } }, Constants.getShopType(row.shopId)));
                        // }

                        btns.push(h("div", { style: { color: "#ff0000", textAlign: "center", fontSize: "18px" } }, row.shippingCarrier));

                        if (params.row.insp == 1) {
                            subS.push(h("span", { style: { color: "#ff0000", textAlign: "center" } }, "验货，"));
                        }
                        if (params.row.type == 2) {
                            subS.push(h("span", { style: { color: "#ff0000", textAlign: "center" } }, "仓库存货，"));
                        }
                        if (params.row.big == 1) {
                            subS.push(h("span", { style: { color: "#ff0000", textAlign: "center" } }, "大件货"));
                        }
                        btns.push(h("div", {}, subS));
                        btns.push(h("div", {}, [

                            h("a", { attrs: { href: "/#/waybill/show/" + params.row.waybillOrder, target: "_blank" } }, params.row.orderId)
                        ]));


                        btns.push(h("div", {}, [

                            h("a", { attrs: { href: "/#/waybill/show/" + params.row.waybillOrder, target: "_blank" } }, params.row.waybillOrder)
                        ]));

                        return h("div", { style: {} }, btns);
                    }
                }, {
                    title: '包裹',
                    key: 'userRemark',
                    width: 400,
                    align: 'center',
                    render: (h, params) => {

                        var row = params.row;
                        var me = this;
                        var divs = [];


                        var objs = row.list;

                        for (var i = 0; i < objs.length; i++) {

                            let obj = objs[i];
                            var divitems = [];
                            var state = "";
                            var attr = "";
                            var text = "待签收";
                            var styles = { fontSize: '12px', color: '#fff', padding: '5px' };
                            styles.backgroundColor = "#2db7f5";
                            if (obj.state == -2) {
                                text = "已取消";
                                styles.backgroundColor = "#ed4014";

                            } else if (obj.state == 1) {
                                text = "已签收";
                                styles.backgroundColor = "#19be6b";

                            } else if (obj.state == -1) {
                                text = "拒签退回";
                                styles.backgroundColor = "#ed4014";

                            }
                            if (obj.type == 1) {
                                attr += "快递：";
                                if (obj.fillIn == 1) attr += obj.expressNo;
                            } else {
                                attr += "库存";
                            }

                            var ps = obj.pics.split("##");

                            var divimages = [];
                            for (var j = 0; j < ps.length; j++) {

                                if (ps[j] != '') {
                                    //CarouselItem
                                    divimages.push(h("div", {}, [h("img", {
                                        style: {},
                                        attrs: { src: ps[j] },
                                        on: {
                                            click: (e) => {
                                                var t = e.currentTarget.currentSrc;
                                                me.imgName = t;
                                                me.title = obj['remark'];
                                                me.visible = true;
                                            }
                                        }
                                    })]));

                                }
                            }

                            divitems.push(h("div", { class: ["express-item-images"] }, [
                                h("div", { arrow: "always", radiusDot: true }, divimages)
                            ]));


                            var divitems2 = [];
                            divitems2.push(h("div", { class: "express-item-name", attr: { alt: obj['remark'] } }, obj['remark']));
                            divitems2.push(h("div", { class: "express-item-attr", attr: { alt: attr } }, attr));

                            //操作
                            var spanope = [];
                            var spanope2 = [];
                            spanope.push(h("span", { style: styles, class: "express-item-attr", attr: {} }, text));
                            if (obj.state == 1)
                                spanope.push(h("Button", { style: { marginLeft: "5px" }, props: { size: "small", type: "error" }, on: { click: () => { this.back(obj); } } }, "未签收退回"));

                            if (obj.wareRemark) {
                                spanope2.push(h("span", { style: styles, class: "express-item-attr", attr: {} }, "仓库备注:" + obj.wareRemark));
                            }
                            spanope2.push(h("Button", {
                                style: { marginLeft: "5px" },
                                props: { size: "small", type: "primary" },
                                on: {
                                    click: () => {
                                        // this.remark(obj);
                                        this.waybillExpress = obj;
                                        this.showRemark = true;
                                    }
                                }
                            }, "设置备注"));


                            divitems2.push(h("div", {}, spanope));
                            divitems2.push(h("div", {}, spanope2));



                            divitems.push(h("div", { class: "express-item-product" },
                                divitems2));
                            if (row.multi == 1) {
                                divitems.push(h("img", { style: { position: "absolute", top: "5px", left: "-15px", width: "50px", zIndex: "1" }, attrs: { src: "/mult.png" } }));
                            }

                            if (i == 0) {
                                divs.push(h("div", {
                                    class: "express-item"
                                }, divitems));
                            } else {
                                divs.push(h("div", { class: [1 == 1 ? "express-item" : "", row.showmore ? "showmore" : "hidemore"] }, divitems));
                            }


                        } //end for 
                        if (objs.length > 1) {
                            var txt = !row.showmore ? ("还有" + (objs.length - 1) + "个快递") : "点击收起";
                            divs.push(h("div", {
                                class: "tipsClass",
                                on: {
                                    click: () => {
                                        row.showmore = !row.showmore;
                                    }
                                }
                            }, txt))
                        }


                        return h("div", { style: { textAlign: "left" } }, divs);

                    }

                },
                {
                    title: '商家备注',
                    key: 'userRemark',
                    width: 200,
                    align: 'center'
                },

                {
                    title: '处理备注',
                    key: 'remark',
                    width: 180,
                    align: 'center'
                },

                {
                    title: '状态',
                    key: 'createTime',
                    width: 180,
                    align: 'center',
                    render: (h, params) => {
                        var me = this;
                        var row = params.row;
                        var btns = [];
                        var color = "#000";

                        btns.push(h("div", { style: {} }, "创建:" + me.long2datetime(params.row.createTime)));
                        if (row.state > 0) {
                            color = "#ff9900";
                            // btns.push(h("div", { style: {} }, "审核:" + me.long2datetime(params.row.lastSubmitTime)));
                        }
                        if (row.state > 1) {
                            color = "#2db7f5";
                            btns.push(h("div", { style: {} }, "签收:" + me.long2datetime(params.row.signTime)));
                        }

                        if (row.state > 2) {
                            color = "#19be6b";

                            btns.push(h("div", { style: {} }, "出库:" + me.long2datetime(params.row.outgoingTime)));
                        }
                        if (row.state == -2) {
                            color = "#ed4014";
                            btns.push(h("div", { style: {} }, "取消:" + me.long2datetime(params.row.cancelTime)));

                        }

                        btns.push(h("div", { style: { backgroundColor: color, color: '#fff' } }, Constants.getWithdrawState(params.row.state)));


                        return h("div", { style: { paddingTop: '10px', paddingBottom: '10px' } }, btns);
                    }
                },
                {
                    title: '手续费',
                    key: 'baseFee',
                    width: 160,
                    align: 'center',
                    render: (h, params) => {
                        var btns = [];
                        btns.push(h("div", {}, params.row.userName));
                        btns.push(h("div", "基础费用：" + params.row.baseFee.toFixed(2)));
                        btns.push(h("div", "验货费用：" + params.row.inspFee.toFixed(2)));
                        btns.push(h("div", "加价费用：" + params.row.increateFee.toFixed(2)));
                        btns.push(h("div", "其他费用：" + params.row.otherFee.toFixed(2)));
                        return h("div", btns);
                    }
                },
                {
                    title: '操作',
                    key: 'state',
                    width: 250,
                    fixed: 'left',
                    className: "tabname",
                    align: 'center',
                    render: (h, params) => {
                        var row = params.row;

                        var btns0 = []
                        var btns1 = [];
                        var btns2 = [];
                        var btns3 = [];
                        var btns4 = [];
                        var btns100 = [];
                        if (row.splitUp == 1)
                            btns100.push(h("div", { class: "sub-title" }, [
                                h("div", { class: 'packageName cross' }, '拆分订单')
                            ]));
                        btns1.push(h("Button", { style: { marginRight: "5px" }, props: { size: "small", type: "primary" }, on: { click: () => { this.chuli(params.index); } } }, "已处理过了"));


                        let dts = [h("Button", {
                            props: { size: "small", loading: row.loading },
                            on: {
                                click: () => {
                                    this.asyncDetail(row, true);
                                }
                            }
                        }, "同步订单状态")];

                        if (row.errorState != 1) {
                            dts.push(
                                h("Button", { style: { marginRight: "5px" }, props: { size: "small", type: "warning" }, on: { click: () => { this.setError(row); } } }, "设为异常"));
                        }
                        btns0.push(h("div", { style: { marginBottom: "10px" } }, dts));

                        if (row.state == -2) {
                            btns2.push(h("Button", { style: { marginRight: "5px" }, props: { size: "small", type: "error" }, on: { click: () => { this.okdelete(row); } } }, "彻底删除"));
                        }

                        if (row.state != -2 && row.state != 4) {
                            btns2.push(h("Button", { style: { marginRight: "5px" }, props: { size: "small", type: "error" }, on: { click: () => { this.delete(row); } } }, "取消订单"));
                        }

                        if (row.state == 2) {
                            btns2.push(h("Button", {
                                style: { marginRight: "5px" },
                                props: { size: "small", type: "primary" },
                                on: {
                                    click: () => {
                                        this.ok(row, params.index);
                                    }
                                }
                            }, "扫码出库"));
                        } else if (row.state == 1) {
                            btns2.push(h("Button", { style: { marginRight: "5px" }, props: { size: "small", type: "error" }, on: { click: () => { this.fouce(row); } } }, "强制出库"));
                        }





                        if (row.big != 1)
                            btns3.push(h("Button", {
                                style: { marginRight: "5px" },
                                props: { size: "small", type: "error" },
                                on: {
                                    click: () => {
                                        this.waybill = row;
                                        this.showBig = true;
                                    }
                                }
                            }, "设为大件" + (row.shopId == 1 ? ",店配" : "")));
                        if (row.state != -2)
                            btns3.push(h("Button", {
                                style: { marginRight: "5px" },
                                props: { size: "small", type: "warning" },
                                on: {
                                    click: () => {
                                        this.waybill = row;
                                        this.showGap = true;
                                    }
                                }
                            }, "补差价"));



                        if (row.cross == 1) {

                            btns4.push(h("Button", { style: { marginRight: "5px" }, props: { loading: row.asyncPdfLoading, size: "small", type: "success" }, on: { click: () => { this.printPdf(row, params.index); } } }, "打印面单"));
                            btns4.push(h("a", { class: "ivu-btn ivu-btn-error ivu-btn-small", style: { marginRight: "5px" }, attrs: { target: "_blank", href: row.waybillPath }, on: { click: () => {} } }, "下载面单"));
                        } else {

                            btns4.push(h("Button", { style: { marginRight: "5px" }, props: { loading: row.asyncWaybillLoading, size: "small", type: "success" }, on: { click: () => { this.printWaybill(row, params.index); } } }, "打印交接单"));

                            btns4.push(h("Button", { style: { marginRight: "5px" }, props: { loading: row.asyncPdfLoading, size: "small", type: "error" }, on: { click: () => { this.printLocalPdf(row, params.index); } } }, "打印本土面单"));
                        }


                        return h("div", { style: { margin: "10px 0px" } }, [
                            h("div", btns1),
                            h("div", btns100),

                            h("div", { style: { marginTop: "10px" } }, btns0),
                            h("div", { style: { marginTop: "10px" } }, btns2),
                            h("div", { style: { marginTop: "10px" } }, btns3),
                            h("div", { style: { marginTop: "10px" } }, btns4)
                        ]);
                    }
                }

            ]
        };
    },
    mounted: function() {
        this.setMouse(true);
        this.initPrint();
    },
    components: {
        CPrintSet,
        CXiapiLogistics,
        CWaybillBig,
        CWaybillGap,
        CWaybillBack,
        CWaybillError,
        CWaybillExpressRemark,
        CWaybillExpressBack

    },
    computed: {

    },
    beforeRouteLeave(to, form, next) {
        if (this.fouceTimer) {
            window.clearInterval(this.fouceTimer)
        }
        next()

    },
    methods: {

        setMouse(val) {
            var me = this;
            if (val) {
                me.fouceTimer = setInterval(function() {
                    me.$refs['expressNo'].focus();
                }, 500);
            } else {
                if (this.fouceTimer) {
                    window.clearInterval(this.fouceTimer)
                }
            }
        },
        setError: function(id) {
            this.waybill = id;
            this.showError = true;
        },
        updateDetail: function() {
            var me = this;
            if (me.selected.length <= 0) {
                me.$message.error("请先选择要更新的订单");
                return false;
            }
            var ids = [];
            for (var i = 0; i < me.selected.length; i++) {
                ids.push(me.selected[i].orderId);
            }
            for (var j = 0; j < me.waybills.length; j++) {
                var sn = me.waybills[j].orderId;
                if (ids.indexOf(sn) != -1) {

                    if (!me.waybills[j].loading)
                        me.asyncDetail(me.waybills[j], false);
                }

            }
        },
        asyncDetail: function(row, state) {
            var me = this;
            row.loading = true;
            me.$http.post("/ware/waybill/asyncdetail.action", { ordersns: row.orderId }).then(response => {
                var body = response;
                if (body.status == 0) {
                    if (state) {
                        me.successMessage("更新成功");
                    }
                    row.orderStatus = body.obj;
                }
                row.loading = false;
            }, response => {
                row.loading = false;
            });

        },
        updateLogist: function() {
            var me = this;
            if (me.selected.length <= 0) {
                me.$Message.error("请先选择要更新的订单");
                return false;
            }
            var ids = [];
            for (var i = 0; i < me.selected.length; i++) {
                ids.push(me.selected[i].orderId);
            }
            for (var j = 0; j < me.waybills.length; j++) {
                var sn = me.waybills[j].orderId;
                if (ids.indexOf(sn) != -1) {

                    if (!me.waybills[j].asyncLoading)
                        me.getLogistics(me.waybills[j], false);
                }

            }

        },
        getLogistics: function(row, state) {
            var me = this;
            row.asyncLoading = true;
            me.$http.post("/ware/waybill/getLogistisc.action", { ordersn: row.orderId, trackingNo: row.waybillOrder, shopId: row.shopId }).then(response => {

                var body = response;
                if (body.status == 0) {
                    row.lastLogistics = body.info;
                } else {
                    if (state)
                        me.$message.error("获取异常！");
                }
                row.asyncLoading = false;
            }).catch(error => {

                row.asyncLoading = false;
            });
        },
        handleSelectAll(status) {
            this.$refs.selection.selectAll(status);
        },
        selectionChange: function(selection) {

        },
        selectAllCancel: function(selection) {
            this.selected = selection;
        },
        selectAll: function(selection) {
            this.selected = selection;
        },
        selectCancel: function(selection, row) {
            this.selected = selection;
        },
        select: function(selection, row) {
            this.selected = selection;
        },
        xiapiLogCancel: function() {
            this.xiapiLogShow = false;
            this.waybill = {};
        },
        chuli: function(ind) {

            this.orders.splice(ind, 1);
        },
        printCallback: function(ordersn, waybillId) {
            this.$http.post("/ware/waybill/printCallback.action", { ordersn: ordersn, waybillId: waybillId }).then(response => {});
        },
        okdelete: function(row) {

        },
        remark: function(obj) {

            //仓库备注
            this.waybillExpress = obj;
            this.showRemark = true;
        },
        back: function(obj) {
            this.waybillExpress = obj;
            this.state = -1;
            this.showExpressBack = true;
        },
        backOk: function(rk) {
            this.showExpressBack = false;
            this.waybillExpress.remark = rk;
            this.waybillExpress.state = -1;
        },
        remarkOk: function(rk) {
            this.waybillExpress.wareRemark = rk;
            this.showRemark = false;
        },
        ok: function(row, index) {
            var me = this;
            me.$Modal.confirm({
                title: "提示",
                content: "是否确定扫码出库操作",
                onOk: function() {
                    me.showLoading();
                    me.$http.post("/ware/waybill/doOutgoing.action", { id: row.id }).then(response => {
                        me.hideLoading();
                        var body = response;
                        if (body.status == 0) {
                            //移除掉

                            me.orders.splice(index, 1);

                        } else {
                            me.$Message.error("操作异常!" + body.info);
                        }
                    }).catch(error => {
                        me.hideLoading();
                    });
                },
                onCancel: function() {

                }
            });
        },
        delete: function(id) {
            this.waybill = id;
            this.showBack = true;
        },
        toGo: function() {
            var me = this;
            if (!me.expressNo) return;
            var obj = { expressNo: me.expressNo, state: 0 };
            me.$http.post("/ware/waybillexpress/signexpress.action", { expressNo: me.expressNo }).then(response => {
                var body = response;
                obj['msg'] = body.info;
                if (body.status == 0) {
                    for (var i = 0; i < body.obj.length; i++) {
                        var bj = { msg: body.info, expressNo: body.obj[i].expressNo, state: 1, waybillOrder: body.obj[i].waybillOrder };

                        body.obj[i]['showmore'] = true;
                        body.obj[i]['asyncPdfLoading'] = false;
                        body.obj[i]['asyncWaybillLoading'] = false;

                        body.obj[i]["loading"] = false;
                        body.obj[i]["asyncLoading"] = false;
                        me.resultOrders.unshift(bj);
                    }
                    me.orders = body.obj;

                    iNotify.player("expressok");
                } else {

                    obj['state'] = -1;
                    iNotify.player("expresserror");
                    me.orders =[];
                    me.resultOrders.unshift(obj);
                }

            }, response => {
                obj['msg'] = "请求异常";
                obj['state'] == -1;
                me.resultOrders.unshift(obj);
                iNotify.player("expresserror");
            });



            me.expressNo = "";
            me.$refs['expressNo'].focus();

        },
        toSearch: function() {
            var me = this;
            if (!me.expressNo2) return;
            me.resultOrders = [];
            me.$http.post("/ware/waybillexpress/getList.action", { expressNo: me.expressNo2, state: 0, current: 1, pageSize: 100 }).then(response => {

                var body = response;
                if (body.status == 0) {

                    me.resultOrders = body.obj.list;

                }
            }, response => {


            });
            me.expressNo2 = "";


        },

        doConnect: function(callback) {
            let serviceUrl = "ws://localhost:13528";
            var me = this;
            me.socket = new WebSocket(serviceUrl);

            // 监听消息
            me.socket.onmessage = function(event) {
                // console.log('Client received a message', event);

                let data = JSON.parse(event.data);

                if (data.cmd == "getPrinters") {

                    if (!me.printName) {
                        me.printName = data.defaultPrinter;
                        localStorage.setItem("defaultPrinter", me.printName);
                    }
                    me.printers = data.printers;

                } else if (data.cmd == 'print') {

                    if (data.msg == "成功" && data.status == "success") {
                        //已发送打印
                        iNotify.player("printOk");
                        me.printCallback(me.orders[me.currentIndex].orderId, me.orders[me.currentIndex].id);
                        me.chuli(me.currentIndex);
                    } else {
                        iNotify.player("printError");
                    }
                }

            };

            me.socket.onopen = function(event) {
                if (callback != null) {
                    callback();
                }

            }

            me.socket.onerror = function(error) {
                // console.log("Failed to connect CN print at " + serviceUrl, error);

            }

            // 监听Socket的关闭
            me.socket.onclose = function(event) {
                console.log('Client notified socket has closed', event);

            };
        },
        initPrint() {

            if (!this.socket || typeof this.socket == "undefined" || this.socket.readyState == WebSocket.CLOSED) {
                this.doConnect(this.initPrint);
                return;
            }
            if (this.socket && typeof this.socket != "undefined" && this.socket.readyState == 1) {
                this.printName = localStorage.getItem("defaultPrinter");
                this.getPrinters();
            } else {
                this.printName = "";
            }
        },
        getPrinters() {
            this.socket.send(JSON.stringify({
                "cmd": "getPrinters",
                "requestID": getRand(),
                "version": "1.0"
            }));
        },
        printSetOk: function(name) {
            this.printName = name;
            localStorage.setItem("defaultPrinter", name);
            this.printerShow = false;
        },
        setDayin() {
            if (!this.socket || typeof this.socket == "undefined" || this.socket.readyState == WebSocket.CLOSED) {
                //
                this.$message.error("暂未安装打印控件")
                return;
            }
            this.printerShow = true;
        },
        printLocalPdf(row, ind) {
            //本土面单
            var me = this;
            row.asyncPdfLoading = true;
            me.$http.post("/ware/waybill/printLocalPdf.action", { ordersn: row.orderId }).then(response => {
                var body = response;
                if (body.status == 0) {
                    window.open(body.obj);
                } else {
                    me.$message.error(body.info);
                }
                row.asyncPdfLoading = false;
            }).catch(error => {
                me.$Message.error("操作异常!" + error);
                row.asyncPdfLoading = false;
            });


        },
        printWaybill(row, ind) {
            var me = this;
            me.currentIndex = ind;
            // alert(me.currentIndex);
            if (!me.socket || typeof me.socket == "undefined" || me.socket.readyState == WebSocket.CLOSED) {
                //
                me.$message.error("暂未安装打印控件")
                return;
            } else {
                if (!this.printName) {
                    me.$message.error("请先设置打印机");
                    return;
                }
                row.asyncWaybillLoading = true;
                me.$http.post("/ware/waybill/printWaybill.action", { ordersn: row.orderId }).then(response => {
                    var body = response;
                    if (body.status == 0) {
                        //发送到打印机
                        let time = new Date().getTime() + getRand();
                        let orderData = [];
                        orderData.push({
                            "documentID": row.orderId,
                            "contents": [{
                                data: body.obj,
                                templateURL: "https://cloudprint.cainiao.com/print/resource/getResource.json?resourceId=10079856&status=0"
                            }]
                        });
                        let printData = {
                            "cmd": "print",
                            "version": "1.0",
                            "requestId": time,
                            "task": {
                                "taskID": "tk" + time,
                                "preview": false,
                                "printer": me.printName,
                                "notifyMode": "allInOne",
                                "previewType": "pdf",
                                "documents": orderData
                            }
                        }
                        //转成json
                        me.socket.send(JSON.stringify(printData))
                    } else {
                        me.$Message.error(body.info);
                    }
                    row.asyncWaybillLoading = false;
                }).catch(error => {
                    me.$Message.error("操作异常!" + error);
                    row.asyncWaybillLoading = false;
                });
            }
        },
        printPdf(row, ind) {
            var me = this;
            me.currentIndex = ind;
            // alert(me.currentIndex);
            if (!me.socket || typeof me.socket == "undefined" || me.socket.readyState == WebSocket.CLOSED) {
                //
                me.$message.error("暂未安装打印控件")
                return;
            } else {
                if (!this.printName) {
                    me.$message.error("请先设置打印机");
                    return;
                }

                row.asyncPdfLoading = true;
                me.$http.post("/ware/waybill/printPdf.action", { shopId: row.shopId, ordersn: row.orderId, folderId: row.folderId,outgoOk:me.outgoOk }).then(response => {
                    var body = response;
                    if (body.status == 0) {
                        //发送到打印机
                        let time = new Date().getTime() + getRand();
                        let orderData = [];
                        orderData.push({
                            "documentID": row.orderId,
                            "contents": [{
                                data: body.obj,
                                templateURL: "https://cloudprint.cainiao.com/print/resource/getResource.json?resourceId=9956246&status=0"
                            }]
                        });
                        let printData = {
                            "cmd": "print",
                            "version": "1.0",
                            "requestId": time,
                            "task": {
                                "taskID": "tk" + time,
                                "preview": false,
                                "printer": me.printName,
                                "notifyMode": "allInOne",
                                "previewType": "pdf",
                                "documents": orderData
                            }
                        }
                        //转成json
                        me.socket.send(JSON.stringify(printData))
                    } else {
                        me.$Message.error(body.info);
                    }
                    row.asyncPdfLoading = false;
                }).catch(error => {
                    me.$Message.error("操作异常!" + error);
                    row.asyncPdfLoading = false;
                });
            }
        }
    }
}
</script>
<style scoped>
</style>